import React, { useEffect } from 'react';
import { apiUrl } from '../config/config';
import axios from 'axios';

const RazorpayBadge = () => {

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className='razporpaybadgediv'
        dangerouslySetInnerHTML={{
          __html: `<razorpay-trusted-business key="rzp_test_zBRbbqzLkyRdsa"></razorpay-trusted-business>`,
        }}
        />
    </div>
  );
}

export default RazorpayBadge;